import React from 'react';

const FacebookIcon = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="40" height="40" rx="20" fill="#1877F2" />
    <path d="M28.2852 25.7812L29.1719 20H23.625V16.25C23.625 14.668 24.3984 13.125 26.8828 13.125H29.4062V8.20312C29.4062 8.20312 27.1172 7.8125 24.9297 7.8125C20.3594 7.8125 17.375 10.582 17.375 15.5938V20H12.2969V25.7812H17.375V39.7578C18.3945 39.918 19.4375 40 20.5 40C21.5625 40 22.6055 39.918 23.625 39.7578V25.7812H28.2852Z" fill="white" />
  </svg>
);

export default FacebookIcon;